import { render, staticRenderFns } from "./SignupForm.vue?vue&type=template&id=b7d983ea&scoped=true&"
import script from "./SignupForm.vue?vue&type=script&lang=ts&"
export * from "./SignupForm.vue?vue&type=script&lang=ts&"
import style0 from "./SignupForm.vue?vue&type=style&index=0&id=b7d983ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d983ea",
  null
  
)

export default component.exports